/**
 * It converts a number to a boolean.
 * @param {number} value - number
 * @returns A boolean value.
 */
export default function numberAsBoolean(value: number) {
  return Boolean(value || value === 0)
}
